import type { ReactNode } from 'react'
import { useMemo } from 'react'

import { CircleLogoMastercardIcon, CircleLogoVisaIcon } from '@twisto/icons'

import { Input } from './input'
import type { InputProps } from './input-common'

export type CardProviders = 'visa' | 'mastercard' | 'other'

type Props = { name: string; cardProvider: CardProviders } & Omit<
  InputProps,
  'type'
>

const cardLogo: Record<CardProviders, ReactNode> = {
  visa: <CircleLogoVisaIcon data-testid="visa-logo" size="20" />,
  mastercard: (
    <CircleLogoMastercardIcon data-testid="mastercard-logo" size="20" />
  ),
  other: null,
}

export const CardNumberInput = ({
  error = false,
  focused = false,
  cardProvider,
  ...props
}: Props) => {
  const other = { ...props, error, focused }

  const EndAdornment = useMemo(
    () => <div>{cardLogo[cardProvider]}</div>,
    [cardProvider]
  )

  return (
    <Input
      data-testid="card-number-input"
      endAdornment={EndAdornment}
      type="text"
      {...other}
    />
  )
}
